module.exports = __webpack_public_path__ + "img/paperclip.17405178.svg";